import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { KazaplanDiaporamaComponent } from '../kazaplan-diaporama.component';
import { KazaplanFullscreenService } from '../../kazaplan-fullscreen/kazaplan-fullscreen.service';
import { share, switchMap, take, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { of } from 'rxjs/internal/observable/of';
import { PlanMediaType } from '../../../../shared/models/kaza/plan';
import { environment } from 'environments/environment';
import { Observable, Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { UserStoreService } from '../../../../shared/services/state-management/user-store.service';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsTrashcan } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-trashcan.icon';
import { kzIconsCross } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-cross.icon';
import { Media } from '@adeo/ngx-kozikaza-api/kazaplan';

@Component({
  selector: 'app-kazaplan-diaporama-popin',
  templateUrl: './kazaplan-diaporama-popin.component.html',
  styleUrls: ['../kazaplan-diaporama.component.scss', './kazaplan-diaporama-popin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AutoUnsubscribe()
export class KazaplanDiaporamaPopinComponent extends KazaplanDiaporamaComponent {

  private kazaplanMediasSubscription: Subscription;
  private kazaplanMediaDeleteSubscription: Subscription;

  public $kazaplanSocialShare: Observable<Media>;
  public $kazaplanMedias: Observable<Media[]>;

  public planMediaType = PlanMediaType;

  public baseURL = environment.REDIRECT_URL;

  constructor(
      protected cdr: ChangeDetectorRef,
      public kps: KazaplanFullscreenService,
      public readonly userStoreService: UserStoreService,
      protected kzIconsRegistryService: KzIconsRegistryService,
  ) {
    super(cdr);
    this.kzIconsRegistryService.registerIcons([kzIconsTrashcan, kzIconsCross]);
    this.$kazaplanMedias = this.kps.planMedias.pipe(
        share(),
        tap((planMedias: Array<Media>) => {
          // if filter has been triggered then planMedias.length and then init array
          this.planMediaLoaded = (planMedias.length && (planMedias.length >= this.planMediaLoaded.length)) ?
              [...this.planMediaLoaded, ...Array(planMedias.length - this.planMediaLoaded.length).fill(false)] : [];
        })
    );
    this.$kazaplanSocialShare = combineLatest([this.kps.getKazaplanCurrentMedia(), this.$kazaplanMedias]).pipe(
        switchMap(([mediaIndex, medias]) =>
            ((mediaIndex === -1) ? this.kps.getPlanFeaturedMedia() : of(medias[+mediaIndex])) as Observable<Media>
        )
    );
  }

  public nextMedia(event: any) {
    event.stopPropagation();
    this.kazaplanMediasSubscription = this.kps.nextKazaplanMedia().pipe(take(1)).subscribe();
  }
  public previousMedia(event: any) {
    event.stopPropagation();
    this.kazaplanMediasSubscription = this.kps.previousKazaplanMedia().pipe(take(1)).subscribe();
  }

  public deletePlanMedia(mediaId: string, planId: number) {
    this.kazaplanMediaDeleteSubscription = this.kps.deleteMedia(mediaId, planId).subscribe();
  }

}
